@if (isOverlayMode) {
  <div class="sidebar-backdrop" (click)="toggleSidebar()"></div>
}
<aside class="app-sidebar" [class.collapsed]="isCollapsed" [class.overlay]="isOverlayMode">
  <div class="sidebar-header">
    <div class="sidebar-logo">
      <img [src]="isCollapsed ? logoIcon : logo" alt="ElevateMe Logo" />
    </div>
    <button class="sidebar-toggle" (click)="toggleSidebar()" aria-label="Toggle sidebar">
      <img [src]="isCollapsed ? sidebarExpandIcon : sidebarCollapseIcon" alt="Toggle sidebar" [class.rotated]="isCollapsed" />
    </button>
  </div>
  <nav class="sidebar-nav">
    <ul class="nav-menu">
      @for (item of menuItems; track item.route) {
          <li class="nav-item" [class.has-children]="hasChildren(item)" [class.expanded]="isExpanded(item)">
          <div class="nav-link-wrapper">
            @if (hasChildren(item)) {
              <a
                class="nav-link"
                [href]="sidebarHref(item.route)"
                [class.active]="isRouteActive(item)"
                [title]="isCollapsed ? item.label : ''"
                (click)="handleNavClick(item, $event)"
                (auxclick)="handleNavClick(item, $event)"
              >
                <img [src]="item.iconPath" [alt]="item.label" class="nav-icon" />
                <span class="nav-label" [class.hidden]="isCollapsed">{{ item.label }}</span>
              </a>
            } @else {
              <a
                [routerLink]="item.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: false }"
                class="nav-link"
                [title]="isCollapsed ? item.label : ''"
                (click)="onSidebarLinkClick($event)"
                (auxclick)="onSidebarLinkClick($event)"
              >
                <img [src]="item.iconPath" [alt]="item.label" class="nav-icon" />
                <span class="nav-label" [class.hidden]="isCollapsed">{{ item.label }}</span>
                @if (isInboxItem(item) && inboxUnreadCount > 0) {
                  <span class="nav-badge" [class.collapsed-badge]="isCollapsed">
                    {{ inboxUnreadCount }}
                  </span>
                }
              </a>
            }
            @if (hasChildren(item) && !isCollapsed) {
              <button 
                class="nav-arrow-btn" 
                (click)="toggleSubmenu(item, $event)"
                [class.expanded]="isExpanded(item)"
                aria-label="Toggle submenu"
              >
                <img [src]="chevronRightIcon" alt="Arrow" class="nav-arrow" />
              </button>
            }
          </div>
          @if (hasChildren(item) && isExpanded(item) && !isCollapsed) {
            <div class="submenu-container">
              <div class="submenu-connector"></div>
              <ul class="submenu">
                @for (child of item.children; track child.route) {
                  <li class="submenu-item">
                    <a
                      [routerLink]="child.route"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      class="submenu-link"
                      (click)="onSidebarLinkClick($event)"
                      (auxclick)="onSidebarLinkClick($event)"
                    >
                      <span class="submenu-label" [attr.title]="child.label">{{ child.label }}</span>
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </li>
      }
    </ul>
  </nav>
</aside>

